/* RESPONSIBLE TEAM: team-standalone  */

import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';

export default class RequestAccessRoute extends Route {
  @service declare finStandaloneService: FinStandaloneService;

  beforeModel(_transition: Transition) {
    return this.finStandaloneService.loadBasePlatformConfigs();
  }
}
